// Get the height of the visible content on the page
var visibleContentHeight = Math.max(
  document.documentElement.clientHeight,
  window.innerHeight || 0
);

const opacityTriggerPoint = document.querySelector(
  ".scroll-to-top-position-holder"
);
// Calculate the equivalent rootMargin in pixels
var rootMargin = -1 * visibleContentHeight;

// Options for the Intersection Observer
const options = {
  root: null, // Use the viewport as the root
  threshold: 0, // Trigger the callback when the target element enters the viewport
  rootMargin: `0px`, // Offset by -100vh from the top
};
const scrollToTopBtn = document.getElementById("scrollToTopBtn");

// Callback function for the Intersection Observer
function handleIntersection(entries, observer) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      // Target element is in the viewport, set opacity to 0
      scrollToTopBtn.style.opacity = 0;
      scrollToTopBtn.style.pointerEvents = "none";
    } else {
      // Target element is out of the viewport, set opacity to 1
      scrollToTopBtn.style.opacity = 1;
      scrollToTopBtn.style.pointerEvents = "all";
    }
  });
}

// Create a new Intersection Observer
var observer = new IntersectionObserver(handleIntersection, options);

// Start observing the scroll position of the page (document body)
observer.observe(opacityTriggerPoint);

// Scroll-to-top button click event listener
document
  .getElementById("scrollToTopBtn")
  .addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
